import { ProjectArchiveResponse } from '@/types/service-response'

export class ProjectArchive {
  public constructor (
    readonly id: number,
    readonly beleg: number | undefined,
    readonly formular: string,
    readonly version: number | undefined,
    readonly belegNummer: string,
    readonly dateiPfad: string,
    readonly dateiName: string,
    readonly verfugbar : boolean
  ) {}

  static createFromResponse (responseData: ProjectArchiveResponse[]): Array<ProjectArchive> {
    let result: Array<ProjectArchive> = []
    if (responseData) {
      result = responseData.map((item: ProjectArchiveResponse ) => {
        return new ProjectArchive(
          item.ID,
          item.Beleg ? item.Beleg : undefined,
          item.Formular ? item.Formular : '',
          item.Version ? item.Version : undefined,
          item.BelegNummer ? item.BelegNummer : '',
          item.DateiPfad ? item.DateiPfad : '',
          item.DateiName ? item.DateiName : '',
          item.Verfugbar ? item.Verfugbar : false
        )
      })
    }
    return result
  }
}
